"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateGuid = generateGuid;
exports.generateShortGuid = generateShortGuid;
/**
 * generuje guid w formacie xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 * @param format N - bez kresek, B - z klamrami, P - z nawiasami
 */
function generateGuid(format) {
    const g = format == 'N' ? 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx' : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    const result = g.replace(/[xy]/g, c => {
        // tslint:disable-next-line:no-bitwise
        const r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    switch (format) {
        case 'B': return '{' + result + '}';
        case 'P': return '(' + result + ')';
    }
    return result;
}
const h16a = '0123456789abcdef'.split("");
/**
 * generuje skrócony guid 12 znaków
 */
function generateShortGuid() {
    let s = "";
    for (let i = 0; i < 12; i++)
        s += h16a[(Math.random() * 16) | 0];
    return s;
}
//# sourceMappingURL=generateGuid.js.map